// extracted by mini-css-extract-plugin
export var icon = "dropDefault-module--icon--dt-Lw";
export var title = "dropDefault-module--title--Llmw8";